import type { StepConfig } from '~/ui-rocco/multi-step-form';
import { ExistingSubmissionStep } from './ExistingSubmissionStep';
import { EventAttendanceStep } from './EventAttendanceStep';
import { GuestInvitationStep } from './GuestInvitationStep';
import { HDEAuthenticationStep } from './HDEAuthenticationStep';
import { ProductInterestsStep } from './ProductInterestsStep';
import { HDESuccessStep } from './HDESuccessStep';
import { ProjectStageStep } from './ProjectStageStep';
import { ProjectScopeStep } from './ProjectScopeStep';
import { ProjectLocationStep } from './ProjectLocationStep';
import { ProjectBudgetStep } from './ProjectBudgetStep';

export const HDE_STEP_CONFIGS: StepConfig[] = [
    {
        id: 'authentication',
        title: 'Register for Home Design Evening',
        component: HDEAuthenticationStep,
        skippable: false,
        /** Footer Continue on desktop; mobile uses in-form submit (see useHDERegistrationForm). */
        conditional: true,
        showBackInsteadOfCancel: true,
    },
    {
        id: 'existing-submission',
        title: 'Register for Home Design Evening',
        component: ExistingSubmissionStep,
        skippable: false,
        allowGoingBack: false,
        hideNextButton: true,
    },
    {
        id: 'project-scope',
        title: 'Your Project Details',
        component: ProjectScopeStep,
        skippable: false,
        advanceOnSelect: true,
        hideNextButton: true,
    },
    {
        id: 'project-stage',
        title: 'Your Project Details',
        component: ProjectStageStep,
        skippable: false,
        advanceOnSelect: true,
        hideNextButton: true,
    },
    {
        id: 'event-attendance',
        title: 'Register for Home Design Evening',
        component: EventAttendanceStep,
        skippable: false,
    },
    {
        id: 'product-interests',
        title: 'Your Project Details',
        component: ProductInterestsStep,
        skippable: false,
        conditional: true,
    },
    {
        id: 'project-budget',
        title: 'Final Step',
        component: ProjectBudgetStep,
        skippable: false,
        advanceOnSelect: true,
        hideNextButton: true,
    },
    {
        id: 'project-location',
        title: 'Your Project Details',
        component: ProjectLocationStep,
        skippable: false,
        advanceOnSelect: true,
        hideNextButton: true,
    },
    {
        id: 'guest-invitation',
        title: 'Register for Home Design Evening',
        component: GuestInvitationStep,
        skippable: false,
        showBackInsteadOfCancel: true,
    },
    {
        id: 'success',
        title: "You're all set!",
        component: HDESuccessStep,
        skippable: false,
        allowGoingBack: false,
        hideNextButton: true,
    },
];
